import script from "./ButtonComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ButtonComponent.vue?vue&type=script&setup=true&lang=ts"

import "./ButtonComponent.vue?vue&type=style&index=0&id=c3a94c88&lang=css"

const __exports__ = script;

export default __exports__